<template lang="html">

	<section class="ficha -empresa">
		
		<template v-if="!!data">

			<h2 class="ficha-title" :style="styles.colorBasic">{{$t('informacion_puesto')}}</h2>

			<article class="group">

				<h3 class="group-title" :style="styles.colorBasic">{{$t('puesto')}}</h3>

				<div class="contenedor-data" v-if="!!data.puesto">
					<h4 class="data-title" :style="styles.colorBasic">{{$t('nombre_oferta')}}</h4>
					<p v-html="data.puesto"></p>
				</div>

				<div class="contenedor-data" v-if="!!data.numeroPlazas">
					<h4 class="data-title" :style="styles.colorBasic">{{$t('n_plazas')}}</h4>
					<p>{{data.numeroPlazas}}</p>
				</div>

				<div class="contenedor-data" v-if="!!data.areaFuncional">
					<h4 class="data-title" :style="styles.colorBasic">{{$t('area_funcional')}}</h4>
					<p v-html="data.areaFuncional"></p>
				</div>
		

				<div class="contenedor-data -full" v-if="!!data.descripcionPuesto">
					<h4 class="data-title" :style="styles.colorBasic">{{$t('descripcion_puesto')}}</h4>
					<p v-html="data.descripcionPuesto"></p>
				</div>

			</article>


            <article class="group">

				<h3 class="group-title" :style="styles.colorBasic">{{$t('duracion')}}</h3>

				<div class="contenedor-data" v-if="!!data.horasAlDia">
					<h4 class="data-title" :style="styles.colorBasic">{{$t('horas_dia')}}</h4>
					<p>{{data.horasAlDia}}</p>
				</div>

				<div class="contenedor-data" v-if="!!data.horario">
					<h4 class="data-title" :style="styles.colorBasic">{{$t('horario')}}</h4>
					<p>{{data.horario}}</p>
				</div>

				<div class="contenedor-data" v-if="!!data.fechaInicio">
					<h4 class="data-title" :style="styles.colorBasic">{{$t('fecha_inicio')}}</h4>
					<p>{{data.fechaInicio}}</p>
				</div>

                <div class="contenedor-data" v-if="!!data.fechaFin">
					<h4 class="data-title" :style="styles.colorBasic">{{$t('fecha_finalizacion')}}</h4>
					<p>{{data.fechaFin}}</p>
				</div>
	

			</article>


            <article class="group">

				<h3 class="group-title" :style="styles.colorBasic">{{$t('localizacion')}}</h3>

				<div class="contenedor-data" v-if="!!data.pais">
					<h4 class="data-title" :style="styles.colorBasic">{{$t('pais')}}</h4>
					<p>{{data.pais}}</p>
				</div>

				<div class="contenedor-data" v-if="!!data.provincia">
					<h4 class="data-title" :style="styles.colorBasic">{{$t('provincia')}}</h4>
					<p>{{data.provincia}}</p>
				</div>

				<div class="contenedor-data" v-if="!!data.localidad">
					<h4 class="data-title" :style="styles.colorBasic">{{$t('poblacion')}}</h4>
					<p>{{data.localidad}}</p>
				</div>
			</article>


            <article class="group">

				<h3 class="group-title" :style="styles.colorBasic">{{$t('detalles')}}</h3>

				<div class="contenedor-data" v-if="!!data.ayudaAlEstudio">
					<h4 class="data-title" :style="styles.colorBasic">{{$t('remuneracion')}}</h4>
					<p>{{data.ayudaAlEstudio}}</p>
				</div>

				<div class="contenedor-data" v-if="!!data.otrasRemuneraciones">
					<h4 class="data-title" :style="styles.colorBasic">{{$t('otras_remuneraciones')}}</h4>
					<p>{{data.otrasRemuneraciones}}</p>
				</div>

			</article>

		</template>

	</section>

</template>

<script lang="js">

	import {mapGetters, mapActions} from 'vuex';

	import onlyArrow  from '@/components/parts/icons/only-arrow';
	import arrowlink  from '@/components/parts/icons/arrow-link';

	export default  {
		name: 'ficha-informacion-puesto',
		props : ['data','contactos'],
		computed :{
			...mapGetters({
				styles : 'getStyles',
				brand : 'getBrand'
			})
		},
		components : {
			'only-arrow' : onlyArrow,
			'arrow-link' : arrowlink,
		}

	}
</script>

<style scoped lang="scss">
	.ficha-empresa {

	}
</style>



// WEBPACK FOOTER //
// src/components/views/aprobaciones/ficha-informacion-puesto.vue